module.exports = __webpack_public_path__ + "img/dog-tablet.b8e4609a.png";